import { Stack } from '@mui/material';
import React from 'react';

import { useCommonStyles } from '~/styles/commonStyles';
import { HappyScaleBoxWithController } from '~/widgets/survey/components/ui/HappyScaleBoxWithController';
import { HappyScaleType } from '~helpers/SurveyHelper';
import { SurveyFormKeyEnum } from '~modules/surveys/forms/SurveyForm';
import { SurveyAnswerTypeIdEnum } from '~modules/surveys/types/SurveyAnswerTypeIdEnum';

interface IHappyScaleProps {
  name: string;
  scaleType: HappyScaleType;
}

export const HappyScale: React.FC<IHappyScaleProps> = (props) => {
  const { name, scaleType } = props;
  const { classes: commonClasses } = useCommonStyles();

  const length = scaleType === SurveyAnswerTypeIdEnum.HAPPY_INDEX_5 ? 5 : 10;

  return (
    <Stack direction="row" display="inline-flex" className={commonClasses.happyScaleContainer}>
      {Array.from({ length }, (_, i) => i + 1).map((happyIndex) => (
        <HappyScaleBoxWithController
          key={happyIndex}
          name={`${name}.${SurveyFormKeyEnum.happyIndex}`}
          value={happyIndex}
          scaleType={scaleType}
        />
      ))}
    </Stack>
  );
};
